import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../../../store";

import * as GalleryStore from "../../../store/Gallery";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Checkbox,
} from "@material-ui/core";

export enum BrowserMode {
  SingleMode = 0,
  MultiMode = 1,
}

interface ImageBrowserProps extends PropsFromRedux {
  browserMode: BrowserMode;
  OnSelectFinished: (selectedItems: Array<string>) => void;
  OnClose: () => void;
}

const ImageBrowser: React.FC<ImageBrowserProps> = ({
  browserMode,
  deleteImages,
  getImages,
  images,
  OnSelectFinished,
  OnClose,
}) => {
  const [imagesRequseted, setImagesRequested] = React.useState<boolean>(false);
  const [selectedImages, setSelectedImages] = React.useState<Array<string>>([]);

  React.useEffect(() => {
    if (!imagesRequseted) {
      setImagesRequested(true);
      getImages();
    }
  }, [imagesRequseted, getImages]);

  const onSelectClick = React.useCallback(() => {
    OnSelectFinished(
      selectedImages.map((a) => `../resources/images/gallery/small/${a}`)
    );
  }, [selectedImages, OnSelectFinished]);

  const onImageSelected = React.useCallback(
    (imgUrl: string, _checked: boolean) => {
      var newArray = selectedImages.filter((i) => i !== imgUrl);
      if (newArray.length === selectedImages.length) {
        setSelectedImages(selectedImages.concat(imgUrl));
      } else {
        setSelectedImages(newArray);
      }
    },
    [selectedImages]
  );

  if (!images) {
    return <></>;
  }

  return (
    <Grid
      container
      direction="row"
      style={{ flexGrow: 1, padding: 20, minWidth: 400, minHeight: 200 }}
    >
      <div
        style={{ position: "fixed", display: "flex", flexDirection: "column" }}
      >
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={onSelectClick}
          disabled={
            selectedImages.length === 0 ||
            (browserMode === BrowserMode.SingleMode &&
              selectedImages.length > 1)
          }
        >
          Select
        </Button>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={OnClose}
          style={{ marginTop: 10 }}
        >
          Cancel
        </Button>
      </div>
      <Grid item xs={12}>
        <Grid container justify="center" spacing={2}>
          {images.map((element) => (
            <Grid key={element} item>
              <Card style={{ width: 300 }}>
                <CardMedia
                  component="img"
                  height="190"
                  image={`./resources/images/gallery/small/${element.replace(
                    /^.*[\\/]/,
                    ""
                  )}`}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{
                      textOverflow: "ellipsis",
                      display: "inline-block",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      width: 268,
                    }}
                  >
                    {element}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Checkbox
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      onImageSelected(element, event.target.checked);
                    }}
                  />
                  <Button
                    size="small"
                    color="secondary"
                    onClick={async () => {
                      await deleteImages([element]);
                      // setImagesRequested(false);
                    }}
                  >
                    Delete
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  images: state.gallery?.images,
});

const mapDispatch = {
  getImages: () => GalleryStore.actionCreators.getImages(),
  deleteImages: (images: string[]) =>
    GalleryStore.actionCreators.deleteImages(images),
};

const connector = connect(mapStateToProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ImageBrowser);
